import { useNavigate } from 'react-router-dom'
import { useContext, useState } from 'react'
import { UserDetailsContext } from '../../../../context/user-details/user-details'
import { IPostLocation } from '../../../../shared/services/location/location.model'
import LocationService from '../../../../shared/services/location/location.service'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'
import moment from 'moment'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods'
import { LocationNewForm } from '../../../presentation-components/organisation-components/location/location-new-form'
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels'

export const OrganisationLocationNewPage = () => {
  const navigate = useNavigate();
  //Services
  const locationService = LocationService.getInstance();
  const userNotificationsContext = useContext(UserNotificationsContext)
  const userDetailsContext = useContext(UserDetailsContext)
  const organisationId = userDetailsContext.userDetails?.organisation.id
  const reportPeriodContext = useContext(ReportPeriodContext)
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [errorCode, setErrorCode] = useState<number>()
  const [isFormSubmitting, setIsFormSubitting] = useState<boolean>(false)
  const [newLocation, setNewLocation] = useState<IPostLocation>({
    friendlyName: '',
    buildingTypeId: '',
    countryId: 'GBR',
    startDate: moment(
      reportPeriodContext.allReportPeriods.find(r => r.id === reportPeriodContext.lastSelectedReportId)?.startDate
      ?? moment()
    ).format('YYYY-MM-DD HH:mm:ss.SSS Z'),
    organisationId: organisationId || '',
    isPrimaryLocation: false,
    ownership: '',
    hasOperationalControl: true,
    customFieldValues: [],
  })

  const submitHandler = async (newLocationForm: IPostLocation) => {
    if (!isFormSubmitting) {
      setErrorMessage('')
      setIsFormSubitting(true)
      locationService.create(newLocationForm)
        .then(response => {
          refreshLocationsandRedirect(response.id);
        })
        .catch(err => {
          setIsFormSubitting(false)
          console.log(err)
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  function refreshLocationsandRedirect(newLocationId: string | undefined): void {
    locationService.getAllLocations(true)
      .then(() => {
        setIsFormSubitting(false)
        userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
        if (newLocationId) {
          navigate(`/organisation/locations/${newLocationId}`)
        } else {
          navigate("/organisation/locations")
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={`Add New ${screenLabelsContext.getLabel('location', { plural: false, capitalize: 'first' })}`}
        includeBackButton={true}
        backButtonLink='/organisation/locations'
        backButtonText={`Back to ${screenLabelsContext.getLabel('location', { plural: true })}`}
      />
      <LocationNewForm
        isSubmitting={isFormSubmitting}
        newLocation={newLocation}
        submitHandler={submitHandler}
        errorCode={errorCode}
        errorMessage={errorMessage} />
    </PageOuterContainer>
  )
}